import { TransactionStatus } from '../../graphql'

export const STATUS_TO_HUMAN_READABLE = {
	[ TransactionStatus.Cancelled ]: 'Cancelled',
	[ TransactionStatus.Pending ]: 'Pending',
	[ TransactionStatus.Submitted ]: 'Waiting on approval',
	[ TransactionStatus.Processing ]: 'Processing',
	[ TransactionStatus.Completed ]: 'Completed',
	[ TransactionStatus.Split ]: 'Split',
}
